export default "{\n    \"helperText\": \"Which categories does this favorite relationship apply to?\"\n}\n"